export const API_VERSION = 'v1';



// WEBPACK FOOTER //
// ./src/app/core/api.version.ts